const ko = {
  common: {
    appName: '여론 모니터링 시스템',
    loading: '로딩 중...',
    noData: '데이터 없음',
    confirm: '확인',
    cancel: '취소',
    save: '저장',
    edit: '편집',
    delete: '삭제',
    add: '추가',
    search: '검색',
    export: '내보내기',
    back: '뒤로',
    next: '다음',
    prev: '이전',
    submit: '제출',
    reset: '재설정',
    close: '닫기',
    all: '전체',
    total: '총',
    actions: '작업',
    status: '상태',
    type: '유형',
    name: '이름',
    time: '시간',
    operation: '작업',
    success: '성공',
    failed: '실패',
    yes: '예',
    no: '아니오',
    page: '페이지',
    of: '/',
    items: '건',
    selectPlaceholder: '선택해 주세요',
    inputPlaceholder: '입력해 주세요',
    viewOriginal: '원문 보기',
  },
  nav: {
    dashboard: '대시보드',
    monitor: '모니터링',
    monitorManage: '모니터링 관리',
    monitorData: '데이터 모니터링',
    analysis: '분석',
    volume: '볼륨 모니터',
    publicOption: '이벤트 분석',
    report: '보고서',
    settings: '설정',
    settingsWarning: '경고 설정',
    settingsWarningMsg: '경고 메시지',
    settingsPreference: '환경설정',
    settingsFeedback: '피드백',
  },
  login: {
    title: '로그인',
    subtitle: '여론 모니터링 시스템',
    phone: '전화번호',
    phonePlaceholder: '전화번호를 입력하세요',
    password: '비밀번호',
    passwordPlaceholder: '비밀번호를 입력하세요',
    signIn: '로그인',
    signingIn: '로그인 중...',
    logout: '로그아웃',
    invalidCredentials: '전화번호 또는 비밀번호가 잘못되었습니다',
  },
  dashboard: {
    title: '대시보드',
    todayStatus: '오늘의 여론 현황',
    warningAlerts: '경고 여론',
    hotEvents: '핫 이벤트',
    hotSearch: '인기 검색어',
    leadersOpinion: '지도자 여론',
    pushOpinion: '푸시 여론',
    reprintQuery: '전재 조회',
    collection: '수집 게시물',
    hotWeibo: 'Weibo 트렌드',
    hotWechat: 'WeChat 트렌드',
    hotDouyin: 'Douyin 트렌드',
    hotBilibili: 'Bilibili 트렌드',
    onlineUsers: '온라인 사용자',
    dailyReport: '일일 보고',
    weeklyReport: '주간 보고',
  },
  monitor: {
    title: '모니터링 관리',
    addGroup: '그룹 추가',
    editGroup: '그룹 편집',
    deleteGroup: '그룹 삭제',
    addProject: '프로젝트 추가',
    editProject: '프로젝트 편집',
    deleteProject: '프로젝트 삭제',
    groupName: '그룹 이름',
    projectName: '프로젝트 이름',
    projectType: '프로젝트 유형',
    normal: '일반',
    advanced: '고급',
    subjectWord: '주요 키워드',
    characterWord: '인물 키워드',
    eventWord: '이벤트 키워드',
    regionalWord: '지역 키워드',
    stopWord: '제외 키워드',
    projectDescription: '설명',
    selectProject: '모니터링 관리 페이지에서 프로젝트를 선택하세요',
    deleteConfirm: '정말 삭제하시겠습니까?',
    groupDeleteConfirm: '이 그룹을 삭제하면 그룹 내 모든 프로젝트도 삭제됩니다. 계속하시겠습니까?',
    dataList: '데이터 모니터링',
    articleTitle: '기사 제목',
    sourceName: '출처',
    publishTime: '게시 시간',
    emotion: '감성',
    positive: '긍정',
    neutral: '중립',
    negative: '부정',
    similarCount: '유사 수',
    sourcePlatform: '출처 플랫폼',
    keyword: '키워드',
    timeRange: '기간',
    hours24: '24시간',
    today: '오늘',
    yesterday: '어제',
    days3: '3일',
    days7: '7일',
    days15: '15일',
    days30: '30일',
    days365: '1년',
    custom: '사용자 정의',
    emotionFilter: '감성 필터',
    sourceFilter: '출처 필터',
    sortBy: '정렬 기준',
    timeDesc: '시간 내림차순',
    timeAsc: '시간 오름차순',
    similarDesc: '유사수 내림차순',
    matchMode: '매칭 방식',
    fullText: '전문',
    titleOnly: '제목만',
    contentOnly: '본문만',
    preciseFilter: '정밀 필터',
    mergeSimilar: '유사 병합',
    sourcePlatforms: '소스 플랫폼',
    sourcePlatformsHint: '모니터링할 플랫폼 선택',
    platformsCount: '플랫폼',
    projectPlatforms: '프로젝트 플랫폼',
    sourcePlatformFilter: '소스 플랫폼',
  },
  analysis: {
    title: '모니터링 분석',
    dataOverview: '데이터 개요',
    emotionalProportion: '감성 비율',
    planWordHit: '주요 키워드 적중',
    keywordEmotionTrend: '키워드 감성 추이',
    hotEventRanking: '핫 이벤트 순위',
    highwordCloud: '키워드 클라우드',
    keywordIndex: '고빈도어 지수',
    mediaActivity: '미디어 활동도 분석',
    hotSpotRanking: '핫스팟 순위',
    dataSourceDistribution: '데이터 출처 분포',
    dataSourceAnalysis: '데이터 출처 분석',
    keywordExposureRank: '키워드 노출도 순위',
    selfmediaVolumeRank: '셀프미디어 볼륨 순위',
    popularInformation: '인기 정보',
    popularEvent: '인기 이벤트',
    hotCompany: '핫 기업',
    hotPeople: '핫 인물',
    hotSpot: '핫 지역',
    relativeNews: '관련 뉴스',
    categoryRank: '카테고리 추이',
    industrialDistribution: '산업 분포',
    eventStatistics: '이벤트 통계',
    keywordEmotionStatistical: '키워드 감성 통계 분포',
    timePeriod: '기간',
    update: '분석 업데이트',
    totalArticles: '총 기사 수',
    newsCount: '뉴스 수',
    socialCount: '소셜 수',
  },
  volume: {
    title: '볼륨 모니터',
    totalVolume: '총 볼륨',
    newsVolume: '뉴스 볼륨',
    socialVolume: '소셜 볼륨',
    keywordEmotionStatistical: '키워드 감성 통계 분포',
    keywordSourceDistribution: '키워드 출처 분포',
    keywordNewsRank: '키워드 뉴스 순위',
    topicClusterAnalysis: '주제 클러스터 분석',
    keywordEmotionTrend: '키워드 감성 추이',
    highwordCloud: '키워드 클라우드',
    keywordExposureRank: '키워드 노출도 순위',
    keywordCorrelationNews: '핫 콘텐츠 클러스터 순위',
    userPortraitLabel: '사용자 페르소나 라벨',
    socialUserVolumeRank: '소셜 네트워크 사용자 볼륨 순위',
    mediaUserVolumeRank: '셀프미디어 사용자 볼륨 순위',
  },
  publicOption: {
    title: '이벤트 분석',
    addEvent: '이벤트 생성',
    editEvent: '이벤트 편집',
    deleteEvent: '이벤트 삭제',
    eventName: '작업 이름',
    eventKeywords: '작업 키워드',
    eventStartTime: '시작 시간',
    eventEndTime: '종료 시간',
    eventStopWords: '제외 키워드',
    reportList: '보고서 목록',
    reportDetail: '분석 상세',
    backAnalysis: '추적 분석',
    eventContext: '이벤트 맥락',
    eventTrace: '이벤트 추적',
    hotAnalysis: '핫 분석',
    netizensAnalysis: '주요 네티즌 분석',
    statistics: '통계',
    propagationAnalysis: '전파 분석',
    thematicAnalysis: '주제 분석',
    unscrambleContent: '콘텐츠 해석',
    judicialOpinion: '사법 여론 분석',
    statusCreating: '생성 중',
    statusFailed: '생성 실패',
    statusSuccess: '생성 완료',
  },
  report: {
    title: '분석 보고서',
    dailyReport: '일일 보고',
    weeklyReport: '주간 보고',
    monthlyReport: '월간 보고',
    reportName: '보고서 이름',
    reportType: '보고서 유형',
    reportPeriod: '보고서 기간',
    reportStatus: '보고서 상태',
    generating: '작업 생성됨',
    editing: '편집 중',
    completed: '편집 완료',
    failed: '편집 실패',
    deleteSelected: '선택 삭제',
    compile: '편집',
    viewDetail: '상세 보기',
    dataOverview: '데이터 개요',
    emotionAnalysis: '감성 분석',
    hotEventRanking: '핫 이벤트 순위',
    mediaActivity: '미디어 활동도 분석',
    selfMediaRanking: '셀프미디어 순위',
    highWordIndex: '고빈도어 지수',
    hotSpotRanking: '핫스팟 순위',
    netizenWordCloud: '네티즌 워드 클라우드',
    mediaWordCloud: '미디어 워드 클라우드',
    hotPeople: '핫 인물',
    hotSpots: '핫 지역',
    topicClustering: '주제 클러스터 분석',
    socialVRanking: '소셜 인플루언서 순위',
  },
  settings: {
    title: '시스템 설정',
    warning: {
      title: '경고 설정',
      warningName: '경고 이름',
      warningWord: '경고 키워드',
      warningSwitch: '경고 스위치',
      warningClassify: '출처 유형',
      warningContent: '경고 내용',
      allContent: '전체',
      sensitiveOnly: '민감만',
      warningMatch: '매칭 방식',
      warningDeduplication: '경고 중복 제거',
      warningSource: '경고 출처',
      systemPush: '시스템 푸시',
      emailPush: '이메일 푸시',
      receiveTime: '수신 시간',
      weekendWarning: '주말 경고',
      warningInterval: '경고 간격',
      realtime: '실시간',
      scheduled: '예약',
      messageList: '경고 메시지',
      edit: '경고 편집',
    },
    preference: {
      title: '환경설정',
      timeRange: '기간',
      preciseFilter: '정밀 필터',
      emotion: '감성',
      similar: '유사 기사',
      sort: '정렬',
      matchMode: '매칭 방식',
      dataSource: '데이터 출처',
      websiteName: '웹사이트 이름',
      author: '저자',
      organization: '관련 기관',
      categoryLabel: '기사 카테고리',
      enterpriseType: '관련 기업',
      highTechType: '하이테크 기업',
      policyLabel: '관련 정책',
      dataSourceType: '데이터 카테고리',
      eventIndex: '관련 이벤트',
      industryIndex: '관련 산업',
      province: '관련 도',
      city: '관련 도시',
    },
    feedback: {
      title: '피드백 및 제안',
      content: '피드백 내용',
      submit: '피드백 제출',
    },
  },
}

export default ko
